import { useActiveOrgWorkspaces } from "@/hooks/organizations";

import useActiveWorkspace from "@/hooks/useActiveWorkspace";
import { CheckIcon } from "@heroicons/react/outline";
import DeleteWorkspace from "./DeleteWorkspace";

const Workspaces = () => {
  const workspaces = useActiveOrgWorkspaces();
  const activeWorkspace = useActiveWorkspace();

  return (
    <div className="mt-2">
      <div className="flex items-center justify-between">
        <div className="flex items-baseline">
          <h1 className="text-lg font-semibold">Workspaces</h1>
        </div>
      </div>
      <div className="mt-2 w-full border-t border-gray-200 pt-4">
        <ul className="space-y-2">
          {workspaces.map((workspace) => (
            <li
              className="flex items-center justify-between rounded-md bg-gray-50 p-2 hover:bg-gray-100"
              key={workspace.id}
            >
              <div className="flex items-center space-x-2">
                <span className="text-gray-700">{workspace.name}</span>
                {workspace.is_admin && (
                  <span className="inline-block rounded-full bg-blue-500 px-2 text-xs text-white">
                    Admin
                  </span>
                )}
              </div>
              <div className="flex items-center space-x-2">
                {workspace.id === activeWorkspace?.id && (
                  <CheckIcon className="h-4 w-4 text-gray-500" />
                )}
                <DeleteWorkspace workspace={workspace} />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Workspaces;
